import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { withRouter } from 'react-router';
import { OrderReviewContext } from './OrderReviewContext';
import FormInput from '../ReactHookForm/FormInput/FormInput';
import { Text } from '../ReactHookForm/Inputs';
import UncontrolledText from '../ReactHookForm/Inputs/UncontrolledText';
import { Label } from '@material-ui/icons';
import Image from '../ReactHookForm/Inputs/Image';
import UncontrolledImage from '../ReactHookForm/Inputs/UncontrolledImage';
import { format } from 'date-fns';

const propTypes = {
  classes: PropTypes.object.isRequired,
  isCancelled: PropTypes.bool,
};

function RemoteInvisionData({ classes }) {
  const {
    state: { remoteInvisionData },
  } = useContext(OrderReviewContext);

  return (
    <Grid item xs={12} className={classes.container}>
      <Card className="border-left-green">
        <CardHeader
          className={classes.cardHeader}
          titleTypographyProps={{ className: classes.cardHeaderTitle }}
          title="Remote Worker Info"
        />
        <CardContent>
          <UncontrolledText disabled label="Contact Name" value={remoteInvisionData.contactName} />
          <UncontrolledText disabled label="Contact Phone" value={remoteInvisionData.contactPhone} />
          <UncontrolledText disabled label="Date Sent" value={format(new Date(remoteInvisionData?.dateSent), 'MM/dd/yyyy')} />
          <div style={{marginTop: '20px', height: "30%", width: "30%"}}>
            <UncontrolledImage label="Contact Photo" src={remoteInvisionData.contactPhotoUri} />
          </div>

        </CardContent>
      </Card>
    </Grid>
  );
}

const styles = theme => ({
  container: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
    padding: 1,
    flex: 1,
  },
  cardContent: {
    padding: '10 !important',
  },
  cardHeader: {
    padding: '12px',
    backgroundColor: '#fafafa',
  },
  cardHeaderTitle: {
    fontSize: '1rem',
    fontWeight: '700',
    textAlign: 'left',
    color: 'var(--jmi-blue)',
  },
  imageContainer: {
    marginTop: '50px'
  }
});

RemoteInvisionData.propTypes = propTypes;
export default withStyles(styles)(withRouter(RemoteInvisionData));
